"use client";

import { CirclePlus, Download, Share, X } from "lucide-react";

import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";

import { Button } from "./ui/button";
import { useAppContext } from "./context-wrapper";

export function InstallDrawer() {
  const { pwa } = useAppContext();

  return (
    <Drawer
      open={pwa.isDrawerOpen}
      onOpenChange={(open) => pwa.setDrawerOpen(open)}
    >
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle title="get the app!" />
          <DrawerDescription className="text-center" asChild>
            <div>
              <span>
                install the app for a better experience and <br />
                receive notifications even when you&apos;re offline
              </span>
              {pwa.isIOS && (
                <ol className="m-auto mt-2">
                  <li>
                    1. tap the &quot;Share&quot; button{" "}
                    <Share className="w-5 h-5 inline mt-[-4px]" />
                  </li>
                  <li>
                    2. choose &quot;Add to Home Screen&quot;{" "}
                    <CirclePlus className="w-5 h-5 inline mt-[-4px]" />
                  </li>
                </ol>
              )}
            </div>
          </DrawerDescription>
        </DrawerHeader>
        <DrawerFooter>
          <div className="flex gap-2 justify-center items-center">
            <DrawerClose asChild>
              <Button size="md" variant="muted">
                Close
                <X />
              </Button>
            </DrawerClose>

            {pwa.isPWA && (
              <Button onClick={pwa.prompt} variant="info" size="md">
                <span>install</span>
                <Download />
              </Button>
            )}
          </div>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
